import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MassEditService {

  workflowAPI: string;
  coreUrl: string;
  constructor(private http: HttpClient) {
      this.workflowAPI = environment.workflowAPI;
      this.coreUrl = environment.coreUrl;
  }

  getAllMassEdit(status:number){
    return this.http.get<any>(`${this.workflowAPI}MassEdit?status=${status}`);
  }
}
